import React from 'react';
import gql from 'graphql-tag';
import withStyles from '@mui/styles/withStyles';
import GqlAutocomplete from './GqlAutocomplete';
import { getUtilitiesClient } from '../../apollo';
import { ProductPriceOverrides, VariationPriceOverrides } from '../../page/fragments/Product';
import { prettyPrice } from '../../util/strings';

const LineItemAutoComplete = props => {
    const {
        category,
        className,
        name,
        onSelect,
        isPurchase,
        label = 'Add Line Item...',
        variations = false,
        ...otherProps
    } = props;
    const convertResults = data => {
        if (!data || !data.readProducts) return null;
        const result = [];
        for (let x = 0; x < data.readProducts.edges.length; x++) {
            const Product = data.readProducts.edges[x].node;
            if (!isPurchase && !Product.AllowPurchase) {
                continue; // not for sale
            }
            if (!!variations && !!Product.Variations && Product.Variations.edges.length) {
                for (let y = 0; y < Product.Variations.edges.length; y++) {
                    const Variation = Product.Variations.edges[y].node;
                    if (!Variation.IsRetired) {
                        const item = {
                            ID: 'V' + Variation.ID,
                            ItemCode: Variation.InternalItemID,
                            BaseAmount: Number(isPurchase ? Variation.Worth : Variation.Price),
                            UnitAmount: Number(isPurchase ? Variation.PurchasePrice : Variation.SellingPrice),
                            GST: isPurchase ? Variation.ITC : Variation.GST,
                            Name:
                                Product.Title +
                                ' | ' +
                                (Variation.ShortDescription ? Variation.ShortDescription : Variation.InternalItemID),
                            Account: isPurchase ? Product.XeroCostsCode : Product.XeroSalesCode,
                            Product: { ...Product },
                            Variation
                        };
                        delete item.Product.Variations;
                        result.push(item);
                    }
                }
            } else {
                const item = {
                    ID: 'P' + Product.ID,
                    ItemCode: Product.InternalItemID,
                    BaseAmount: Number(isPurchase ? Product.BaseWorth : Product.BasePrice),
                    UnitAmount: Number(isPurchase ? Product.PurchasePrice : Product.SellingPrice),
                    GST: isPurchase ? Product.ITC : Product.GST,
                    Name: Product.Title,
                    Account: isPurchase ? Product.XeroCostsCode : Product.XeroSalesCode,
                    Product: { ...Product }
                };
                delete item.Product.Variations;
                result.push(item);
            }
        }
        return result;
    };

    const selectResult = (e, selected) => {
        if (selected) {
            const item = {};
            item.ID = null;
            item.Qty = 1;
            item.ItemCode = selected.ItemCode;
            item.Price = selected.BaseAmount;
            item.XeroAccount = selected.Account;
            item.Title = selected.Name;
            item.GST = selected.GST;
            item.Product = selected.Product;
            item.Variation = selected.Variation;
            if (!!onSelect) return onSelect({ ...item });
            return { ...item };
        }
    };

    return (
        <GqlAutocomplete
            queryClient={getUtilitiesClient()}
            extraLabelFunc={result => (
                <>
                    <small style={{ float: 'left', paddingRight: 12 }}>[{result.ItemCode}]</small>
                    <small style={{ float: 'right', paddingLeft: 12 }}>{prettyPrice(result.UnitAmount || 0)}</small>
                </>
            )}
            convertResults={convertResults}
            label={label}
            readAllQuery={readAllItems}
            clearOnSelect
            onSelect={selectResult}
            {...otherProps}
        />
    );
};

const readAllItems = gql`
    ${ProductPriceOverrides}
    ${VariationPriceOverrides}
    query ReadItems($contains: String, $limit: Int) {
        readProducts(contains: $contains, purchase: true, limit: $limit) {
            edges {
                node {
                    ID
                    InternalItemID
                    Title
                    BaseWorth # costs
                    PurchasePrice # costs
                    ITC # costs
                    XeroCostsCode # costs
                    AllowPurchase # allow for sales (customer purchase!)
                    BasePrice # sales
                    SellingPrice # sales
                    GST # sales
                    XeroSalesCode # sales
                    ...ProductPriceOverrides # sales
                    Variations {
                        edges {
                            node {
                                ID
                                IsRetired
                                InternalItemID
                                ShortDescription
                                ITC # costs
                                Worth # costs
                                PurchasePrice # costs
                                GST # sales
                                Price # sales
                                SellingPrice # sales
                                ...VariationPriceOverrides # sales
                            }
                        }
                    }
                }
            }
            pageInfo {
                totalCount
            }
        }
    }
`;

const styles = () => null;

export default withStyles(styles)(LineItemAutoComplete);
